import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment'

@Injectable({
  providedIn: 'root'
})

export class URLService {
  constructor() {

  }

  //----------------- Account url --------------------------
  public loginUrl: string = environment.DomainFullURL + "Account/login";
  public registerUrl: string = environment.DomainFullURL + "Account/Register";
  public ChangePasswordUrl: string = environment.DomainFullURL + "Account/ChangePassword";
  public confirmEmail: string = environment.DomainFullURL + "Account/ConfirmEmail";
  public resetPasswordUrl: string = environment.DomainFullURL + "Account/ResetPassword";
  public resetPasswordWithTokenUrl: string = environment.DomainFullURL + "Account/ResetPasswordWithToken";
  public resendConfirmEmailUrl: string = environment.DomainFullURL + "Account/ResendConfirmEmail";
  public logoutUrl: string = environment.DomainFullURL + "Account/Logout";
  public AddNotificationSetupUrl: string = environment.DomainFullURL + "Account/AddNotificationSetup";

  //----------------- User url --------------------------
  public GetEmployeesListUrl: string = environment.DomainFullURL + "User/GetEmployeesList";
  public GetUserDetailsUrl: string = environment.DomainFullURL + "User/GetUserDetails";
  public UpdateUserProfileUrl: string = environment.DomainFullURL + "User/UpdateUserProfile";
  public DeleteUserUrl: string = environment.DomainFullURL + "User/DeleteUser";
  public ChangeUserPasswordUrl: string = environment.DomainFullURL + "User/ChangeUserPassword";
  public GetCustomersListUrl: string = environment.DomainFullURL + "User/GetCustomersList";
  public GetBasicWalkInCustomersListUrl: string = environment.DomainFullURL + "User/GetBasicWalkInCustomersList";
  public ValidateEmiratesIdUrl: string = environment.DomainFullURL + "User/ValidateEmiratesId";
  public UpdateWalkInBasicUserProfileUrl: string = environment.DomainFullURL + "User/UpdateWalkInBasicUserProfile";
  public CreateWalkInUserUrl: string = environment.DomainFullURL + "User/CreateWalkInUser";
  public GetAllSystemRolesUrl: string = environment.DomainFullURL + "User/GetAllSystemRoles";
  public CreateUserUrl: string = environment.DomainFullURL + "User/CreateUser";
  public CreateCustomerUrl: string = environment.DomainFullURL + "User/CreateCustomer";
  public GetMyUsersUrl: string = environment.DomainFullURL + "User/GetMyUsers";
  public GetMyAuditUsersUrl: string = environment.DomainFullURL + "User/GetMyAuditUsers";
  public GetCustomerInquiryUrl: string = environment.DomainFullURL + "User/GetCustomerInquiry";
  public GetDashboardsUrl: string = environment.DomainFullURL + "User/GetDashboards";
  //public GetServiceStatusAndTotalEarningForDashboards: string = environment.DomainFullURL + "User/GetServiceStatusAndTotalEarningForDashboards";
  //public GetCategoryWiseIncomePerQuarterReport: string = environment.DomainFullURL + "User/GetCategoryWiseIncomePerQuarterReport";
  //public GetMonthlySubmittedOrdersChartsForDashboards : string = environment.DomainFullURL + "User/GetMonthlySubmittedOrdersChartsForDashboards";
  // public GetTotalEarningForDashboards: string = environment.DomainFullURL + "User/GetTotalEarningForDashboards";
  public GetDashboardData: string = environment.DomainFullURL + "User/GetDashboardData";
  public GetDashboardPopupReport: string = environment.DomainFullURL + "User/GetDashboardPopupReport";
  public GetAllSevice: string = environment.DomainFullURL + "User/GetAllSevice";
  public GetAllImplementation: string = environment.DomainFullURL + "User/GetAllImplementation";
  public GetAllCategory: string = environment.DomainFullURL + "User/GetAllCategory";
  public GetAllCustomer: string = environment.DomainFullURL + "User/GetAllCustomer";
  public GetAllEmployee: string = environment.DomainFullURL + "User/GetAllEmployee";

  //----------------- Upload url --------------------------
  public UploadFileUrl: string = environment.DomainFullURL + "Upload/UploadFile";



  //----------------- Order url --------------------------
  public IsThisServiceAvailableForUser: string = environment.DomainFullURL + "Order/IsThisServiceAvailableForUser";
  public GetCreateRequestDetailsUrl: string = environment.DomainFullURL + "Order/GetCreateRequestDetails";
  public CreateCustomerRequestUrl: string = environment.DomainFullURL + "Order/CreateCustomerRequest";
  public UpdateCustomerRequest: string = environment.DomainFullURL + "Order/UpdateCustomerRequest";
  public ApproveRDCRequest: string = environment.DomainFullURL + "Order/ApproveRDCRequest";
  public GetOrderDetailsUrl: string = environment.DomainFullURL + "Order/GetOrderDetails";
  public GetOrdersListUrl: string = environment.DomainFullURL + "Order/GetOrdersList";
  public GetOrdersServicesListUrl: string = environment.DomainFullURL + "Order/GetOrdersServicesList";
  public ApplyRequestActionUrl: string = environment.DomainFullURL + "Order/ApplyRequestAction";
  public ApplyRequestOrderDetailActionUrl: string = environment.DomainFullURL + "Order/ApplyRequestOrderDetailAction";
  public GetOrderServiceDetailsUrl: string = environment.DomainFullURL + "Order/GetOrderServiceDetails";
  public GetPendingAssignOrdersServicesListUrl: string = environment.DomainFullURL + "Order/GetPendingAssignOrdersServicesList";
  public GetAssignedOrdersServicesListUrl: string = environment.DomainFullURL + "Order/GetAssignedOrdersServicesList";
  public AssignRequestOrderDetailListUrl: string = environment.DomainFullURL + "Order/AssignRequestOrderDetailList";
  public AssignRdcOrderUrl: string = environment.DomainFullURL + "Order/AssignRdcOrder";
  public ApplyForAssignRequestOrderDetailUrl: string = environment.DomainFullURL + "Order/ApplyForAssignRequestOrderDetail";
  public GetPendingAssignApproveOrdersServicesListUrl: string = environment.DomainFullURL + "Order/GetPendingAssignApproveOrdersServicesList";
  public GetCreateResultFormDetailsUrl: string = environment.DomainFullURL + "Order/GetCreateResultFormDetails";
  public GetUserOrdersServiceListUrl: string = environment.DomainFullURL + "Order/GetUserOrdersServiceList";
  public GetCorporateUserOrdersServiceListUrl: string = environment.DomainFullURL + "Order/GetCorporateUserOrdersServiceList";
  public GetPendingPaymentCorporateUserOrdersServiceListUrl: string = environment.DomainFullURL + "Order/GetPendingPaymentCorporateUserOrdersServiceList";
  public SendOtpSMSUrl: string = environment.DomainFullURL + "Order/SendOtpSMS";
  public ExecuteResultFormUrl: string = environment.DomainFullURL + "Order/ExecuteResultForm";
  public ExecuteAssetRDCResultFormUrl: string = environment.DomainFullURL + "Order/ExecuteAssetRDCResultForm";
  public GetPendingAuditAssignOrdersServicesListUrl: string = environment.DomainFullURL + "Order/GetPendingAuditAssignOrdersServicesList";
  public GetAssignedAuditOrdersServicesListUrl: string = environment.DomainFullURL + "Order/GetAssignedAuditOrdersServicesList";
  public AssignAuditRequestOrderDetailListUrl: string = environment.DomainFullURL + "Order/AssignAuditRequestOrderDetailList";
  public GetFilterDetailsUrl: string = environment.DomainFullURL + "Order/GetFilterDetails";
  public UpdateOrderAttachmentUrl: string = environment.DomainFullURL + "Order/UpdateOrderAttachment";
  public UpdateOrderAttachmentRDCUrl: string = environment.DomainFullURL + "Order/UpdateOrderAttachmentRDC";
  
  public GetWebsiteStatisticsUrl: string = environment.DomainFullURL + "Order/GetWebsiteStatistics";
  public DownloadAttachmentUrl: string = environment.DomainFullURL + "Order/DownloadAttachment";
  public GetPricePerPageUrl: string = environment.DomainFullURL + "Order/GetPricePerPage";


  //----------------- Payment url --------------------------
  public CreatePaymentLinkUrl: string = environment.DomainFullURL + "Payment/CreatePaymentLink";
  public CreateBulkPaymentLinkUrl: string = environment.DomainFullURL + "Payment/CreateBulkPaymentLinK";
  public PayBulkOrdersUrl: string = environment.DomainFullURL + "Payment/PayBulkOrders";
  public IsPaymentDonesUrl: string = environment.DomainFullURL + "Payment/IsPaymentDone";


  //----------------- Notification url --------------------------
  public GetMyNotificationCountUrl: string = environment.DomainFullURL + "Notification/GetMyNotificationCount";
  public GetMyNotificationsUrl: string = environment.DomainFullURL + "Notification/GetMyNotifications";
  public GetTopMyNotificationsUrl: string = environment.DomainFullURL + "Notification/GetTopMyNotifications";



  //----------------- External url --------------------------
  public AddNewInquiryUrl: string = environment.DomainFullURL + "External/AddNewInquiry";
  public UpdateInquiryStatusUrl: string = environment.DomainFullURL + "External/UpdateInquiryStatus";


  //----------------- Configuration url --------------------------
  public GetCategoriesUrl: string = environment.DomainFullURL + "Configuration/GetCategories";
  public AddCategoryUrl: string = environment.DomainFullURL + "Configuration/AddCategory";
  public UpdateCategoryUrl: string = environment.DomainFullURL + "Configuration/UpdateCategory";
  public DeleteCategoryUrl: string = environment.DomainFullURL + "Configuration/DeleteCategory";
  public GetServicesUrl: string = environment.DomainFullURL + "Configuration/GetServices";
  public AddServiceUrl: string = environment.DomainFullURL + "Configuration/AddService";
  public UpdateServiceUrl: string = environment.DomainFullURL + "Configuration/UpdateService";
  public DeleteServiceUrl: string = environment.DomainFullURL + "Configuration/DeleteService";
  public GetImplementationsUrl: string = environment.DomainFullURL + "Configuration/GetImplementations";
  public AddImplementationUrl: string = environment.DomainFullURL + "Configuration/AddImplementation";
  public UpdateImplementationUrl: string = environment.DomainFullURL + "Configuration/UpdateImplementation";
  public DeleteImplementationUrl: string = environment.DomainFullURL + "Configuration/DeleteImplementation";
  public GetReasonsUrl: string = environment.DomainFullURL + "Configuration/GetReasons";
  public AddReasonUrl: string = environment.DomainFullURL + "Configuration/AddReason";
  public UpdateReasonUrl: string = environment.DomainFullURL + "Configuration/UpdateReason";
  public DeleteReasonUrl: string = environment.DomainFullURL + "Configuration/DeleteReason";
  public GetUserServiceAssignmentsUrl: string = environment.DomainFullURL + "Configuration/GetUserServiceAssignments";
  public AddUserServiceAssignmentUrl: string = environment.DomainFullURL + "Configuration/AddUserServiceAssignment";
  public UpdateUserServiceAssignmentUrl: string = environment.DomainFullURL + "Configuration/UpdateUserServiceAssignment";
  public DeleteUserServiceAssignmentUrl: string = environment.DomainFullURL + "Configuration/DeleteUserServiceAssignment";
  public GetServiceImplementationsUrl: string = environment.DomainFullURL + "Configuration/GetServiceImplementations";
  public GetWorkingDaysUrl: string = environment.DomainFullURL + "Configuration/GetWorkingDays";
  public UpdateWorkingDayUrl: string = environment.DomainFullURL + "Configuration/UpdateWorkingDay";
  public GetRequestDefaultWorkingDaysUrl: string = environment.DomainFullURL + "Configuration/GetRequestDefaultWorkingDays";
  public UpdateRequestDefaultWorkingDayUrl: string = environment.DomainFullURL + "Configuration/UpdateRequestDefaultWorkingDay";
  public GetReceiptTypesUrl: string = environment.DomainFullURL + "Configuration/GetReceiptTypes";
  public AddReceiptTypeUrl: string = environment.DomainFullURL + "Configuration/AddReceiptType";
  public UpdateReceiptTypeUrl: string = environment.DomainFullURL + "Configuration/UpdateReceiptType";
  public DeleteReceiptTypeUrl: string = environment.DomainFullURL + "Configuration/DeleteReceiptType";

  //----------------- Common url --------------------------
  public GetOrdersListWorkStation: string = environment.DomainFullURL + "Common/GetOrdersListWorkStation";
  public GetDelayOrdersList: string = environment.DomainFullURL + "Common/GetDelayOrdersList";
  public GetWorkFlow: string = environment.DomainFullURL + "Common/GetWorkFlow";

  //--------------------Report & Analytics
  public GetReport: string = environment.DomainFullURL + "ReportAnalytics/GetReport";
  public GetOrdersOverTimeReport: string = environment.DomainFullURL + "ReportAnalytics/GetOrdersOverTimeReport";
  public GetServicePerformanceReport: string = environment.DomainFullURL + "ReportAnalytics/GetServicePerformanceReport";
  public GetTeamPerformanceReport: string = environment.DomainFullURL + "ReportAnalytics/GetTeamPerformanceReport";



  public GetRDCPrimaryDataListUrl: string = environment.DomainFullURL + "RDCTableegh/GetRDCPrimaryDataList";
}



